import React, { useEffect, useState, Fragment } from "react";
import ReportingHeader from "./components/ReportingHeader";
import OperationReport from "./components/OperationReport";
import ReportDoc from "../../printable/ReportToPDF";
import MultiReportDoc from "../../printable/ReportsToPDF"
import {PDFDownloadLink} from "@react-pdf/renderer";
import translate from "../../reusable/translate";

const ReportEditingContainer = ({ commitment }) => {
  const [reports, setReports] = useState(
    commitment.operations
      .map(operation => operation.reports)
      .flat()
      .sort((a, b) => (a.reportStartDate < b.reportStartDate ? 1 : -1))
  );
  const [reportsByYear, setReportsByYear] = useState({});

  useEffect(() => {
    window.scrollTo(0, 0);
    setReports(reports.flat());
    //commitment.reports.sort((a,b) => a.reportStartDate > b.reportStartDate ? 1 : -1)
  }, []);

  useEffect(() => {
    if (!reports || reports.indexOf(undefined) > -1) return;
    let tmp = {};
    reports.forEach(report => {
      if (Object.keys(tmp).includes(report.reportStartDate)) {
        tmp = {
          ...tmp,
          [report.reportStartDate]: tmp[report.reportStartDate].concat(report)
        };
      } else {
        tmp = {
          ...tmp,
          [report.reportStartDate]: [report]
        };
      }
    });

    setReportsByYear(tmp);
  }, [reports]);

  useEffect(() => {
    console.log("reports by year: ", reportsByYear);
  }, [reportsByYear]);

  if(reports.indexOf(undefined) > -1){
    return (
        <div className="container">
          {translate({textKey: "sit.profile.noReports.commitment"})}
        </div>
        )
  }
  return (
    <div className="container">

      {reportsByYear &&
        Object.keys(reportsByYear).map(date => (
          <Fragment>
            <h2>{new Date(date).toLocaleDateString("fi")} - {new Date(reportsByYear[date][0].reportEndDate).toLocaleDateString("fi")}</h2>
            
            {/* Display pdf download button only if there are approved reports */}
            {reportsByYear[date].some(r => r.status === "approved") && (
              <PDFDownloadLink document={<MultiReportDoc
                commitment={commitment}
                author={commitment.organizationName}
                operations={reportsByYear[date]}
                startingDate={reportsByYear[date][0].reportStartDate}
                endingDate={reportsByYear[date][0].reportEndDate}


              />} fileName="raportti.pdf">
                {({ blob, url, loading, error }) =>
                  'Lataa julkaistut raportit tältä aikaväliltä'
                }
              </PDFDownloadLink>
            )}
            {/* display approved reports first, followed by drafts */}
            {reportsByYear[date]
              .sort((a, b) => (a.status === "approved" ? -1 : 1))
              .map(report => (
              <OperationReport
                operation={report}
                startingDate={report.reportStartDate}
                endingDate={report.reportEndDate}
                commitment={commitment}
                sendReport={null}
                setReportsReady={() => null}
                reportsReady={[]}
                editing={true}
                reportId={report.id}
              />
            ))}
          </Fragment>
        ))}
    </div>
  );
};

export default ReportEditingContainer;



// WEBPACK FOOTER //
// ./src/components/profile/reports/ReportEditingContainer.jsx